import React from 'react';
import AudiogramEmptyProfilePicture from './AudiogramEmptyProfilePicture';
import { SpeakerWithDetails } from '@/player-config/src/types/speaker-types';

const AudiogramSpeakerImage: React.FC<{ imgUrl: string | null; speaker: SpeakerWithDetails | undefined }> = ({
  imgUrl,
  speaker
}) => {
  return imgUrl ? (
    <img className="block size-full object-cover" src={imgUrl} alt="Speaker" />
  ) : (
    <AudiogramEmptyProfilePicture speaker={speaker} />
  );
};

export default AudiogramSpeakerImage;
